<script setup>
const user = useUser()
const ui = useUi()
const { getFlashMessageKey } = useHelpers()
const currentTheme = useTechTheme().lowestLevelTheme

const { AnalyticsEvent, track } = useAnalytics()

const votes = computed(() => user.data?.metadata?.interest || [])
const tech = { id: 'other' }
const freeText = ref('')

async function vote () {
  const payload = {
    slug: 'what-certifications-do-you-want',
    votes: [{ value: 'other', text: freeText }]
  }

  user.addToQueue({ method: 'castVote', payload })
  track(AnalyticsEvent.VOTE)

  if (user.isGuest) {
    ui.flashMessageKey = getFlashMessageKey()
    ui.openAuthModal()
  }
}
</script>

<template>
  <div
    class="rounded-2xl p-6 ring-eerie-black hover:ring-1 dark:ring-light-gray"
    :class="{
      'pointer-events-none border border-dodger-shine bg-white dark:bg-eerie-black': votes.includes(tech.id),
      'border border-transparent bg-eerie-black/5 dark:bg-dark-gunmetal': !votes.includes(tech.id)
    }">
    <div
      v-if="votes.includes(tech.id)"
      class="flex h-full items-center justify-between font-bold">
      {{ freeText }}
      <img src="/images/check-blue.svg">
    </div>

    <form
      v-else
      class="flex w-full justify-between"
      @submit.prevent="vote">
      <input
        v-model="freeText"
        type="text"
        name="others"
        class="flex-1 rounded-l-lg border-y-2 border-l-2 border-body-gray bg-transparent p-2 text-sm text-eerie-black placeholder:text-body-gray focus:outline-none dark:text-light-gray"
        placeholder="Enter comma-separated names of languages, frameworks, etc...">
      <button
        type="submit"
        title="Submit"
        class="self-stretch rounded-r-lg px-4 text-black"
        :class="currentTheme?.bgColor || 'bg-azure-radiance'">
        <InlineSvg
          src="/images/icon-check-2.svg"
          class="size-4 fill-current" />
      </button>
    </form>
  </div>
</template>
